import React from 'react';
import {betStatusEnum} from './CommonTypes';
import {useTranslation} from 'react-i18next';
import {StepForm} from "../../models/api/codegen/code";
import {LiveBadge} from "../Results/LiveBadge";

const buttonStyles = {
    IN_PLAY: "text-[#15B5FE] text-nowrap text-left",
    WAITING: "text-[#15B5FE] text-left",
    WINNER: "text-[#37E76E] text-left",
    LOSER: "text-[#FC4748] text-left",
    REFUND: "text-[#FFFFFF] text-left",
    CANCEL: "text-[#ABABAB] text-left",
    CANCELLED: "text-[#828282] text-left",
    RECEIVED: "text-[#FBD830] text-left"
}

interface BetStatusProps {
    betStatus: betStatusEnum;
    calculated: boolean;
    winning?: boolean;
    type: StepForm['type'];
    isChild: boolean;
    parentStatus?: betStatusEnum;
    steps?: StepForm[] | null;
}

export function BetStatusButton(props: BetStatusProps) {
    const {t} = useTranslation();
    const {betStatus, winning, calculated, parentStatus} = props;

    if (calculated) {

        if (props.type !== "ORDINAR" && props.isChild) {
            const name = ((parentStatus && parentStatus === "REFUND") || (betStatus && betStatus === 'REFUND')) ? 'REFUND' : 'RECEIVED';
            return (
                <div className={buttonStyles[name]}>
                    {t(`myBets.betStatus.buttonLabel.${name}`)}
                </div>
            )
        } else {
            if (winning !== undefined) {
                const name = (betStatus && betStatus === "REFUND") ? 'REFUND' : winning ? 'WINNER' : 'LOSER';
                return (
                    <div className={buttonStyles[name]}>
                        {t(`myBets.betStatus.buttonLabel.${name}`)}
                    </div>
                )
            } else {
                return null;
            }
        }

    } else {
        //
        if (props.type === 'EXPRESS') {
            const status = (props.steps && props.steps.map(
                (a) => {
                    let status = (a.fixture && a.fixture.s);
                    return status
                }
            ));
            const arNotLive = (status && status.filter(
                (a) => {
                    return a != 'LIVE'
                }
            ));

            if (arNotLive && arNotLive.length === 0) {
                return (
                    <div
                        className="flex justify-between max-tablet:items-center tablet:items-start netbook:items-center gap-1 max-tablet:flex-row tablet:flex-col desktop:flex-row">
                        <div className={buttonStyles['IN_PLAY']}>
                            {t(`myBets.betStatus.buttonLabel.IN_PLAY`)}
                        </div>
                        <LiveBadge/>
                    </div>
                );
            }
        }

        if (betStatus) {
            return (
                <div
                    className="flex justify-between max-tablet:items-center tablet:items-start gap-1 max-tablet:flex-row tablet:flex-col desktop:flex-row">
                    <div className={buttonStyles[betStatus]}>
                        {t(`myBets.betStatus.buttonLabel.${betStatus}`)}
                    </div>
                    {betStatus === 'IN_PLAY' && (<LiveBadge/>)}
                </div>
            );
        } else {
            return null;
        }
    }


}
